import { Button, Card, Heading, Replace } from '@sparemin/blockhead';
import React from 'react';
import ProgressOverlay from 'components/ProgressOverlay';
import { block } from '../../utils';

export interface DownloadPageRestoringVideoSectionProps {
  aspectRatioName?: string;
}

const DownloadPageRestoringVideoSection: React.FC<DownloadPageRestoringVideoSectionProps> = ({
  aspectRatioName,
}) => {
  return (
    <Card
      header={<></>}
      footer={<></>}
      className={block('restoring-video-section')}
    >
      <div
        className={block('restoring-video-status', {
          [aspectRatioName]: true,
        })}
      >
        <ProgressOverlay in />

        <Heading
          level={1}
          align="center"
          className={block('regenerating-message', {
            [aspectRatioName]: true,
          })}
        >
          This video will be
          <br />
          ready soon.
          <br />
          <br />
          Archived videos can
          <br />
          take up to 24 hours
          <br />
          to be restored.
          <br />
          Please check back
          <br />
          then.
        </Heading>
      </div>

      <Button fluid isDisabled variant="special" startIcon={<Replace />}>
        Restore Now
      </Button>
    </Card>
  );
};

export default DownloadPageRestoringVideoSection;
